import React, { useState, useEffect, createContext } from "react";
import { Switch, Route } from "react-router-dom";
import "./App.scss";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import Home from "./pages/Home";
import PaymentStatus from "./pages/PaymentStatus";
import { EStatusTrip } from "./helpers/const";
import $axios from "./services/axios";
import Tracking from "./pages/Tracking";
import { message, Modal } from "antd";
import dayjs from "dayjs";

const ReachableContext = createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {(name) => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [token, setToken] = useState(localStorage.getItem("saycarIpassToken"));
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    decodeToken();
  }, []);

  const decodeToken = async () => {
    // Lấy token từ URL
    try {
      const queryParams = new URLSearchParams(window.location.search);
      if (
        queryParams.get("verifyToken") ||
        localStorage.getItem("saycarIpassToken")
      ) {
        const verifyToken = queryParams.get("verifyToken");
        if (verifyToken) {
          const res = await $axios.$post("/api/v1/login", {
            VerifyToken: verifyToken,
          });
          localStorage.setItem("saycarIpassToken", res.data.data.token);
          localStorage.setItem(
            "userInfo",
            JSON.stringify(res.data.data.userInfo)
          );
          queryParams.delete("verifyToken");
          setToken(res.data.data.token);
          history.replace({
            pathname: location.pathname,
            search: queryParams.toString(),
          });
        }
      } else {
        modal.error(config);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (location.pathname === "/booking-driver" && token) {
      fetchBookingInfo();
    }
  }, [location, token]);

  const fetchBookingInfo = async () => {
    const end = dayjs();
    const start = end.subtract(6, "day");
    const startTime = start.format("DD/MM/YYYY") + " 00:00:00";
    const endTime = end.format("DD/MM/YYYY") + " 00:00:00";
    try {
      const res = await $axios.$get(
        `/api/v1/transactions/list?startDate=${startTime}&endDate=${endTime}&page=${1}&pageSize=10`
      );
      const histories = res.data.data.data;
      if (histories.length > 0) {
        const bookingId = histories[0].bookingId;
        const resTrip = await $axios.$get(
          `/api/v1/say-car/find-book-by-id?tripId=${bookingId}`
        );
        if (resTrip?.data?.data) {
          if (
            [
              EStatusTrip.IN_PROGRESS,
              EStatusTrip.ACCEPTED,
              EStatusTrip.ON_TRIP,
            ].includes(resTrip?.data?.data?.statusBooking)
          ) {
            message.success("Bạn có chuyến đi chưa hoàn thành!");
            window.location.href = `/tracking?bookingId=${bookingId}`;
          }
        }
      }
    } catch (error) {
    } finally {
    }
  };

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/booking-driver"} />
        <Route
          exact
          path={"/booking-driver"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Route
          exact
          path={"/payment-status"}
          render={(props) => <PaymentStatus {...props} />}
        />
        <Route
          exact
          path={"/tracking"}
          render={(props) => <Tracking {...props} />}
        />
        <Redirect to={"/booking-driver"} />
      </Switch>
    </>
  );
};
export default App;
